export const validateForm = (formData) => {
    const requiredFields = [
        'status',
        'orderDate',
        'terms',
        'currency',
        'inHandsDate',
        'defaultTax',
    ];

    for (let field of requiredFields) {
        if (!formData[field]) {
            console.log(formData[field],"invalid",field)
            return false;
        }
    }

    return true; 
};
